import { IState } from '../data-types'

const getBannerTelegramBottomStatus = (state: IState): boolean =>
  state.popups.isBannerTelegramBottomOpen

export { getBannerTelegramBottomStatus }
